const translations = {
    pageNumber: 'Page {{pageNumber}} of {{totalPages}}'
};

export default translations;
